var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	5487: () => (loadSingletonVersion("default", "react", true, [1,19,2,3], () => (() => (__webpack_require__(5043))))),
	9453: () => (loadSingletonVersion("default", "react-dom", true, [1,19,2,3], () => (() => (__webpack_require__(7950))))),
	2603: () => (loadSingletonVersion("default", "@radix-ui/react-slot", true, [1,1,2,4], () => (() => (__webpack_require__(6851))))),
	4786: () => (loadSingletonVersion("default", "@radix-ui/react-slot", true, [1,1,2,4], () => (() => (__webpack_require__(6590))))),
	1161: () => (loadSingletonVersion("default", "@radix-ui/react-slot", true, [1,1,2,4], () => (() => (__webpack_require__(4473))))),
	4117: () => (loadSingletonVersion("default", "@radix-ui/react-slot", true, [1,1,2,4], () => (() => (__webpack_require__(5485))))),
	5830: () => (loadSingletonVersion("default", "@radix-ui/react-slot", true, [1,1,2,4], () => (() => (__webpack_require__(3978))))),
	5454: () => (loadSingletonVersion("default", "@radix-ui/react-slot", true, [1,1,2,4], () => (() => (__webpack_require__(2506))))),
	5437: () => (loadSingletonVersion("default", "@radix-ui/react-slot", true, [1,1,2,4], () => (() => (__webpack_require__(3357))))),
	9844: () => (loadSingletonVersion("default", "@radix-ui/react-slot", true, [1,1,2,4], () => (() => (__webpack_require__(8088))))),
	4596: () => (loadSingletonVersion("default", "clsx", true, [1,2,1,1], () => (() => (__webpack_require__(8387))))),
	1284: () => (loadSingletonVersion("default", "@radix-ui/react-select", true, [1,2,2,6], () => (() => (__webpack_require__(4202))))),
	2482: () => (loadSingletonVersion("default", "react-day-picker", true, [1,9,13,0], () => (() => (__webpack_require__(9067))))),
	2688: () => (loadSingletonVersion("default", "tailwind-merge", true, [1,3,4,0], () => (() => (__webpack_require__(9359))))),
	3637: () => (loadSingletonVersion("default", "@radix-ui/react-switch", true, [1,1,2,6], () => (() => (__webpack_require__(7943))))),
	3779: () => (loadSingletonVersion("default", "sonner", true, [1,2,0,7], () => (() => (__webpack_require__(6328))))),
	3982: () => (loadSingletonVersion("default", "@radix-ui/react-popover", true, [1,1,1,15], () => (() => (__webpack_require__(9604))))),
	4134: () => (loadSingletonVersion("default", "lucide-react", true, [2,0,562,0], () => (() => (__webpack_require__(2485))))),
	4792: () => (loadSingletonVersion("default", "socket.io-client", true, [1,4,8,1], () => (() => (__webpack_require__(2104))))),
	4898: () => (loadSingletonVersion("default", "@radix-ui/react-avatar", true, [1,1,1,11], () => (() => (__webpack_require__(4439))))),
	5010: () => (loadSingletonVersion("default", "@radix-ui/react-dialog", true, [1,1,1,15], () => (() => (__webpack_require__(5179))))),
	6404: () => (loadSingletonVersion("default", "class-variance-authority", true, [2,0,7,1], () => (() => (__webpack_require__(917))))),
	6419: () => (loadSingletonVersion("default", "@radix-ui/react-tooltip", true, [1,1,2,8], () => (() => (__webpack_require__(8126))))),
	6824: () => (loadSingletonVersion("default", "react-router-dom", true, [1,6,30,2], () => (() => (__webpack_require__(3245))))),
	7124: () => (loadSingletonVersion("default", "@radix-ui/react-tabs", true, [1,1,1,13], () => (() => (__webpack_require__(7127))))),
	7640: () => (loadSingletonVersion("default", "@radix-ui/react-dropdown-menu", true, [1,2,1,16], () => (() => (__webpack_require__(9878))))),
	8883: () => (loadSingletonVersion("default", "@radix-ui/react-label", true, [1,2,1,8], () => (() => (__webpack_require__(5131))))),
	9134: () => (loadSingletonVersion("default", "react-markdown", true, [1,10,1,0], () => (() => (__webpack_require__(3482))))),
	9309: () => (loadSingletonVersion("default", "framer-motion", true, [1,12,23,26], () => (() => (__webpack_require__(7902)))))
};
var initialConsumes = [5487,9453,2603,4786,1161,4117,5830,5454,5437,9844,4596];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"391": [
		1284,
		2482,
		2688,
		3637,
		3779,
		3982,
		4134,
		4792,
		4898,
		5010,
		6404,
		6419,
		6824,
		7124,
		7640,
		8883,
		9134,
		9309
	],
	"470": [
		5487,
		9453,
		2603,
		4786,
		1161,
		4117,
		5830,
		5454,
		5437,
		9844,
		4596
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}